// extracted by mini-css-extract-plugin
export var active = "_im-e";
export var blink = "_im-f";
export var dropDownSelector = "_im-5";
export var dropDownWrapper = "_im-4";
export var fakeCursor = "_im-d";
export var fontSizeButton = "_im-7";
export var formQuillEditor = "_im-0";
export var pressed = "_im-g";
export var qlBlank = "_im-1";
export var textFormattingToolbar = "_im-2";
export var textFormattingToolbarClosed = "_im-3";
export var textFormattingToolbarInline = "_im-6";
export var textToolbarOption = "_im-8";
export var toolbarCell = "_im-a";
export var toolbarCellCollapsed = "_im-b";
export var toolbarOptionHitArea = "_im-c";
export var toolbarOverflow = "_im-9";